import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { Production } from './components/Production';
import { Comparison } from './components/Comparison';
import { Benefits } from './components/Benefits';
import { Trust } from './components/Trust';
import { Upsell } from './components/Upsell';
import { FinalCTA } from './components/FinalCTA';
import { QuoteForm } from './components/QuoteForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-black overflow-x-hidden" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <SocialProof data-id="element-4" />
        <Production data-id="element-5" />
        <QuoteForm data-id="element-6" />
        <Comparison data-id="element-7" />
        <Benefits data-id="element-8" />
        <Trust data-id="element-9" />
        <Upsell data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}